import React, { useEffect,useState } from "react";
import { useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import UserAvatar from "../../images/user.jpg";
import "./DummyDashboard.scss";
import BannerImg from "../../images/background_stretched_300dpi.png";
import {officeName} from "../../services/Functions";
const quickActions = [
  {
    title: "View Applications",
    description: "View and process pending applications",
    icon: DescriptionOutlinedIcon,
  },
  {
    title: "Create New Application",
    description: "Initiate a new application",
    icon: AddBoxOutlinedIcon,
  },
  {
    title: "Search Application",
    description: "Search and track existing applications",
    icon: SearchOutlinedIcon,
  },
  {
    title: "Download Reports",
    description: "Download system reports",
    icon: DownloadOutlinedIcon,
  },
  {
    title: "Manage Profile",
    description: "View and update your profile information",
    icon: PersonOutlineOutlinedIcon,
  },
  {
    title: "System Notices",
    description: "View important announcements",
    icon: NotificationsNoneOutlinedIcon,
  },
];

const recentActivity = [
  {
    title: "You have logged in to the system",
    time: "21-Apr-2026 10:32 AM",
    tone: "blue",
    icon: LoginOutlinedIcon,
  },
  {
    title: "Profile information updated",
    time: "18-Apr-2026 04:15 PM",
    tone: "green",
    icon: PersonAddAlt1OutlinedIcon,
  },
  {
    title: "You processed an application",
    time: "17-Apr-2026 11:09 AM",
    tone: "purple",
    icon: TaskAltOutlinedIcon,
  },
  {
    title: "You have logged in to the system",
    time: "16-Apr-2026 09:41 AM",
    tone: "amber",
    icon: LoginOutlinedIcon,
  },
];

const notices = [
  {
    title: "Welcome to the Portal",
    description:
      "Get started by exploring the quick actions above. You can create, search, and manage your applications from one place.",
    tone: "info",
    icon: InfoOutlinedIcon,
  },
  {
    title: "Profile Completion Required",
    description:
      "Your profile is incomplete. Please update your personal details to ensure smooth access to all features.",
    tone: "warning",
    icon: WarningAmberOutlinedIcon,
  },
  {
    title: "Application Submitted Successfully",
    description:
      "Your recent application has been submitted and is currently under review. You will be notified once processed.",
    tone: "info",
    icon: InfoOutlinedIcon,
  },
  {
    title: "Pending Action Required",
    description:
      "You have 2 applications that require your attention. Please review and take action at your earliest convenience.",
    tone: "warning",
    icon: WarningAmberOutlinedIcon,
  },
];

const MetaBlock = ({ icon: Icon, label, value }) => (
  <Box className="dummy-dashboard__meta-item">
    <Box className="dummy-dashboard__meta-icon">
      <Icon fontSize="small" />
    </Box>
    <Box>
      <Typography className="dummy-dashboard__meta-label">{label}</Typography>
      <Typography className="dummy-dashboard__meta-value">{value}</Typography>
    </Box>
  </Box>
);

const DummyDashboard = () => {
  const {
    name,
    roleName,
    cnic,
    cfcLevelName,
    email,
    phoneNo,
    lastLoginTime,
    profilePicture,
    code
  } = useSelector((state) => state.auth);
    const [subDivisions, setSubDivisions] = useState(
      JSON.parse(window.localStorage.getItem("subDivisions")) || [],
    );
     const [officeNameForDashboard, setOfficeNameForDashboard] = useState(
        officeName(code ? code : '', subDivisions),
      );
useEffect(()=>{
setOfficeNameForDashboard(officeName(code, subDivisions));
},[code, subDivisions])
    
  const dashboardMeta = [
    {
      label: "Role",
      value: roleName,
      icon: PersonOutlineOutlinedIcon,
    },
    {
      label: "Office",
      value: code === '10' ? "Power Information Technology Company(PITC)":officeNameForDashboard,
      icon: BusinessOutlinedIcon,
    },
    {
      label: "Last Login",
      value: lastLoginTime,
      icon: AccessTimeOutlinedIcon,
    },
  ];

  const userDetails = [
    { label: "Full Name", value: name, icon: PersonOutlineOutlinedIcon },
    { label: "CNIC", value: cnic, icon: AssignmentOutlinedIcon },
    { label: "Role", value: roleName, icon: BusinessOutlinedIcon },
    { label: "Office / Subdivision", value: officeNameForDashboard, icon: BusinessOutlinedIcon },
    { label: "Email", value: email, icon: MailOutlineOutlinedIcon },
    { label: "Phone", value: phoneNo, icon: PhoneOutlinedIcon },
  ];

  const handleOpenProfileEditPopup = () => {
    window.dispatchEvent(new Event("open-profile-edit-popup"));
  };

  return (
    <Box className="dummy-dashboard">
      <Box className="dummy-dashboard__surface">
        <Box className="dummy-dashboard__hero">
          <img
            src={BannerImg}
            alt=""
            className="dummy-dashboard__hero-bg"
          />
          <Box className="dummy-dashboard__hero-copy">
            <Typography className="dummy-dashboard__welcome">
              Welcome back, {name} <span>👋</span>
            </Typography>

            <Stack className="dummy-dashboard__meta" direction="row" spacing={0} useFlexGap flexWrap="wrap">
              {dashboardMeta.map((meta) => (
                <MetaBlock key={meta.label} {...meta} />
              ))}
            </Stack>
          </Box>
        </Box>
        <Box className="dummy-dashboard__content">
          {/* <Typography className="dummy-dashboard__section-title">
            Quick Actions
          </Typography> */}

          {/* <Grid container spacing={2.25} className="dummy-dashboard__quick-actions">
            {quickActions.map((action) => {
              const ActionIcon = action.icon;

              return (
                <Grid item xs={12} sm={6} md={4} lg={2} key={action.title}>
                  <Card className="dummy-dashboard__action-card">
                    <CardContent className="dummy-dashboard__action-card-content">
                      <Box className="dummy-dashboard__action-icon">
                        <ActionIcon fontSize="small" />
                      </Box>
                      <Typography className="dummy-dashboard__action-title">
                        {action.title}
                      </Typography>
                      <Typography className="dummy-dashboard__action-description">
                        {action.description}
                      </Typography>
                      <Box className="dummy-dashboard__action-arrow">
                        <ChevronRightRoundedIcon />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid> */}

          <Grid container spacing={2.25} className="dummy-dashboard__panels">
          <Grid item xs={12} lg={4}>
            <Card className="dummy-dashboard__panel-card">
              <CardContent className="dummy-dashboard__panel-card-content">
                <Box className="dummy-dashboard__panel-header">
                  <Box className="dummy-dashboard__panel-header-left">
                    <PersonOutlineOutlinedIcon fontSize="small" />
                    <Typography>User Information</Typography>
                  </Box>
                  {/* <Typography
                    className="dummy-dashboard__panel-link"
                    onClick={handleOpenProfileEditPopup}
                    sx={{ cursor: "pointer" }}
                  >
                    <EditOutlinedIcon fontSize="small" />
                    Edit Profile
                  </Typography> */}
                </Box>

                <Divider className="dummy-dashboard__divider" />

                <Box className="dummy-dashboard__user-area">
                  <Avatar
                    src={profilePicture || UserAvatar}
                    alt={name}
                    className="dummy-dashboard__avatar"
                  />
                  <Box>
                    <Typography className="dummy-dashboard__user-name">
                      {name}
                    </Typography>
                  </Box>
                </Box>

                <Box className="dummy-dashboard__details">
                  {userDetails.map((detail) => {
                    const DetailIcon = detail.icon;

                    return (
                      <Box className="dummy-dashboard__detail-row" key={detail.label}>
                        <Box className="dummy-dashboard__detail-label-wrap">
                          <DetailIcon fontSize="small" />
                          <Typography className="dummy-dashboard__detail-label">
                            {detail.label}
                          </Typography>
                        </Box>
                        <Typography className="dummy-dashboard__detail-value">
                          {detail.value}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* <Grid item xs={12} lg={4}>
            <Card className="dummy-dashboard__panel-card">
              <CardContent className="dummy-dashboard__panel-card-content">
                <Box className="dummy-dashboard__panel-header">
                  <Box className="dummy-dashboard__panel-header-left">
                    <AccessTimeOutlinedIcon fontSize="small" />
                    <Typography>Recent Activity</Typography>
                  </Box>
                  <Typography className="dummy-dashboard__panel-link">
                    View All
                  </Typography>
                </Box>

                <Divider className="dummy-dashboard__divider" />

                <Box className="dummy-dashboard__activity-list">
                  {recentActivity.map((activity, index) => {
                    const ActivityIcon = activity.icon;

                    return (
                      <Box className="dummy-dashboard__activity-item" key={`${activity.title}-${index}`}>
                        <Box className={`dummy-dashboard__activity-dot dummy-dashboard__activity-dot--${activity.tone}`}>
                          <ActivityIcon className="dummy-dashboard__activity-symbol" fontSize="small" />
                        </Box>
                        <Box>
                          <Typography className="dummy-dashboard__activity-title">
                            {activity.title}
                          </Typography>
                          <Typography className="dummy-dashboard__activity-time">
                            {activity.time}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </CardContent>
            </Card>
          </Grid> */}

          <Grid item xs={12} lg={8}>
            <Card className="dummy-dashboard__panel-card">
              <CardContent className="dummy-dashboard__panel-card-content">
                <Box className="dummy-dashboard__panel-header">
                  <Box className="dummy-dashboard__panel-header-left">
                    <NotificationsNoneOutlinedIcon fontSize="small" />
                    <Typography>Announcements / Notices</Typography>
                  </Box>
                  <Typography className="dummy-dashboard__panel-link">
                    View All
                  </Typography>
                </Box>

                <Divider className="dummy-dashboard__divider" />

                <Stack spacing={1.75} className="dummy-dashboard__notice-list">
                  {notices.map((notice) => {
                    const NoticeIcon = notice.icon;

                    return (
                      <Box key={notice.title} className={`dummy-dashboard__notice-card dummy-dashboard__notice-card--${notice.tone}`}>
                        <Box className="dummy-dashboard__notice-icon">
                          <NoticeIcon fontSize="small" />
                        </Box>
                        <Box>
                          <Typography className="dummy-dashboard__notice-title">
                            {notice.title}
                          </Typography>
                          <Typography className="dummy-dashboard__notice-description">
                            {notice.description}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default DummyDashboard;